declare global {
  interface Window {
    _paq: Array<[string, ...(string | number)[]]>
  }
}

export class Matomo {
  public static init(siteId: string | number, trackerUrl: string) {
    if (typeof window === 'undefined') {
      return
    }

    window._paq = window._paq || []

    window._paq.push(['setSiteId', siteId])
    window._paq.push(['setTrackerUrl', `${trackerUrl}/matomo.php`])
    window._paq.push(['enableLinkTracking'])

    const script = document.createElement('script')
    script.async = true
    script.src = `${trackerUrl}/matomo.js`
    document.head.appendChild(script)
  }

  public static trackPageView(url: string, title?: string) {
    if (!Array.isArray(window._paq)) {
      return
    }
    
    window._paq.push(['setCustomUrl', url])
    if (title) {
      window._paq.push(['setDocumentTitle', title])
    }
    window._paq.push(['trackPageView'])
  }

  public static setUserId(userId: string) {
    if (!Array.isArray(window._paq)) {
      return
    }
    window._paq.push(['setUserId', userId])
  }
}
